import { chartColors } from '../../../SocialReturnOnInvestment/SroiGraphs/RedesignedSroiGraphs/HeadcountAndPerStakeholderImpact/styles'

export const customBoxSpan = document.createElement('div')
const boxSpanInner = document.createElement('span')
const lineLeft = document.createElement('span')
const lineRight = document.createElement('span')

lineLeft.style.backgroundColor = chartColors.perStakeholderImpact
lineRight.style.backgroundColor = chartColors.perStakeholderImpact
lineLeft.style.height = '3px'
lineRight.style.height = '3px'
lineLeft.style.width = '8px'
lineRight.style.width = '8px'

boxSpanInner.style.display = 'flex'
boxSpanInner.style.alignItems = 'center'
boxSpanInner.style.justifyContent = 'center'
boxSpanInner.style.fontSize = 10
boxSpanInner.style.backgroundColor = chartColors.perStakeholderImpact
boxSpanInner.style.height = '16px'
boxSpanInner.style.width = '14px'
boxSpanInner.style.borderRadius = '3px'
boxSpanInner.style.color = 'white'
boxSpanInner.innerText = '£' // todo PBR-1088 use currency symbol from endpoint when it's available

customBoxSpan.style.display = 'flex'
customBoxSpan.style.alignItems = 'center'
customBoxSpan.style.justifyContent = 'space-between'
customBoxSpan.style.gap = 3
customBoxSpan.style.height = '16px'
customBoxSpan.style.width = '40px'
customBoxSpan.style.marginRight = '10px'

customBoxSpan.appendChild(lineLeft)
customBoxSpan.appendChild(boxSpanInner)
customBoxSpan.appendChild(lineRight)

export const customBoxSpansTemplate = {
  1: customBoxSpan
}

export const customContainerStyles = {
  flexDirection: 'row-reverse'
}
